import React from "react";

const YearDropDown = ({ schoolYears, returnOptions = false }) => {
  if (!schoolYears?.endYear) return returnOptions ? [] : null;

  const startYear = 2020;
  const endYear = schoolYears.endYear;

  const options = [];

  for (let i = startYear; i < endYear; i++) {
    options.push({
      label: `${i}-${i + 1}`,
      value: i + 1,
    });
  }

  // New usage: return react-select options
  if (returnOptions) {
    return options;
  }

  // Existing usage: return JSX
  return (
    <>
      {options.map((item) => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </>
  );
};

export default YearDropDown;
